module.exports = __webpack_public_path__ + "img/saturn2.c72cbf1f.png";